import React from "react";
import { BottomSheet } from "react-spring-bottom-sheet";
import CloseIcon from "../assets/images/close.svg";

const FilterModal = ({
  open,
  setOpen,
  onDismiss,
  selectedCategories,
  selectedLevel,
  allCategories,
  toggleCategory,
  toggleLevel,
  floors,
  filterData,
  query,
}) => {
  return (
    <BottomSheet
      open={open}
      onDismiss={onDismiss}
      header={false}
      snapPoints={({ maxHeight }) => [maxHeight, maxHeight]}
      className="rounded-t-lg flex flex-col p-4 relative h-full overflow-auto z-[9999999] "
    >
      <div className="flex flex-row items-center px-4 pt-4 gap-4">
        <img src={CloseIcon} className="w-6 h-6" onClick={onDismiss} />
        <span>Filter</span>
      </div>

      <div className="flex flex-col">
        <span className="p-4 text-xs font-bold text-[#556675]">Category</span>
        {allCategories.map((e) => {
          return (
            <div className="px-4">
              <div
                className="flex items-center justify-between"
                key={e._id + "dd"}
              >
                <label className="text-base font-normal cursor-pointer text-gray-600">
                  {e.name}
                </label>

                <input
                  id={e._id}
                  type="checkbox"
                  value="true"
                  checked={selectedCategories.includes(e._id)}
                  onChange={() => toggleCategory(e._id)}
                  className="w-5 h-5 appearance-none border cursor-pointer border-gray-300 rounded-md checked:bg-no-repeat checked:bg-center checked:bg-checked"
                />
              </div>
              <hr className="h-px my-4 bg-[#EDEDED] border-0" />
            </div>
          );
        })}
        <div className="h-2 bg-[#EDEDED] my-2"></div>

        <span className="p-4 text-xs font-bold text-[#556675]">Level</span>
        {floors.map((e) => {
          return (
            <div className="px-4">
              <div
                className="flex items-center justify-between"
                key={e._id + "dd"}
              >
                <label className="text-base font-normal cursor-pointer text-gray-600">
                  {e.name}
                </label>

                <input
                  id={e._id}
                  type="checkbox"
                  value="true"
                  checked={selectedLevel.includes(e.name)}
                  onChange={() => toggleLevel(e.name)}
                  className="w-5 h-5 appearance-none border cursor-pointer border-gray-300 rounded-md checked:bg-no-repeat checked:bg-center checked:bg-checked"
                />
              </div>
              <hr className="h-px my-4 bg-[#EDEDED] border-0" />
            </div>
          );
        })}
      </div>
    </BottomSheet>
  );
};

export default FilterModal;
